import React from 'react';
import { useT } from './LocaleContext';
import { GlobalStyle } from './styles/GlobalStyles';
import { NotFoundContainer, Title, Message, StyledLink } from './styles/NotFoundPageStyles';


const NotFoundPage = () => {
  const t = useT();
  return (
    <NotFoundContainer>
      <GlobalStyle />
      <Title>404</Title>
      <Message>{t('notFound.message')}</Message>
      <StyledLink to="/">{t('notFound.goHome')}</StyledLink>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
